export default __webpack_public_path__ + "static/media/agricultural-2.16e6ebfc.jpg";